export { default } from './ActiesVandaag';
